const AGENTS_URL = '/agents/me';

export const getMe = $axios => $axios.$get(`${AGENTS_URL}`);
